// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Route, NavigationGuardNext} from 'vue-router';
import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

export enum ExploreMoreRouteNames {
  ExploreMorePage = 'ExploreMorePage',
  ChangeInvestmentModelPage = 'ChangeInvestmentModelPage',
  RiskAssessmentPage = 'RiskAssessmentPage',
  ExploreMoreTab = 'ExploreMoreTab',
  SelectInvestmentOptionPage = 'SelectInvestmentOptionPage',
  ChangeInvestmentConfirmPage = 'ChangeInvestmentConfirmPage',
}

export default [
  {
    path: '/clientdashboard/exploreMore',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/layouts/authenticated/Index.vue'),
    meta: {
      useLayouts: true,
    },
    children: [
      {
        path: '',
        name: ExploreMoreRouteNames.ExploreMoreTab,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/components/exploreMore/ExploreMoreWrapper.vue'),
        meta: {
          useLayouts: true,
        },
        beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
          await store.dispatch('risk/fetchRtqData');
          next();
        },
      },
    ],
  },
  {
    path: '/clientdashboard/exploreMore/change-investment',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/layouts/authenticated/Index.vue'),
    meta: {
      useLayouts: true,
    },
    children: [
      {
        path: '',
        name: ExploreMoreRouteNames.ChangeInvestmentModelPage,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/explore/ChangeInvestmentModelStepper.vue'),
        meta: {
          useLayouts: true,
        },
        beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
          await store.dispatch('risk/fetchRtqData');
          next();
        },
      },
    ],
  },
];
